import parameters from "../../../config/parameters";
import configs from "../../../config/config";

export const fetchClubsByAccounts = ( arrAccounts ) => {
    const clubPlayers = arrAccounts.filter( acc => acc.typeId === parameters.accountTypes.player );
    const clubList = clubPlayers.map( acc => {
        const {clubId, isGlobal} = acc;
        let clubRole = parameters.clubRoles.PLAYER;
        let adminAccount, union, unionId;
        let clubName = acc.clubName;

        // Try to find corresponding admin/owner account
        //
        adminAccount = arrAccounts.find( pl => pl.typeId === parameters.accountTypes.club && pl.id === clubId );
        if( !!adminAccount  ) {
            clubRole = parameters.clubRoles.OWNER;
            union = adminAccount.union || false;
            unionId = adminAccount.unionId || false;
            clubName = adminAccount.nickname;
        } else {
            // If no owner account was find, lets try with manager/agent
            //
            adminAccount = arrAccounts.find( pl => pl.clubAccountId === acc.id && ( pl.typeId === parameters.accountTypes.agent || pl.typeId === parameters.accountTypes.manager ));
            if( !!adminAccount ) {
                clubRole = adminAccount.typeId === parameters.accountTypes.agent ? parameters.clubRoles.AGENT : parameters.clubRoles.MANAGER;
            }
        }
        return {
            clubId,
            clubName,
            clubRole,
            adminAccount,
            isGlobal,
            union,
            unionId,
            playerAccount: acc
        };
    });
    return clubList;
};

export const getGlogalAccountData = ( arrAccounts ) => {
    const gbAccount = arrAccounts.find( acc => acc.isGlobal );
    let usdWallet, dmdWallet;

    if( gbAccount ) {
        usdWallet = gbAccount.wallets[0];
        dmdWallet = gbAccount.wallets[0];
    }

    return {
        ...gbAccount,
        diamonds: dmdWallet.balance,
        diamondsName: dmdWallet.name,
        money: usdWallet.balance,
        moneyName: usdWallet.name
    };
};

export const dataURLtoFile = toUrl => {
    const base64ToBlob = dataurl => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1]
        const sliceSize = 1024;
        const byteChars = window.atob(arr[1]);
        const byteArrays = [];
        for (let offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
            let slice = byteChars.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: mime });
    };

    const getFilename = (dataUrl) => {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        return Math.round(+new Date() / 1000) + '.' + mime.split('/').pop();
    };
    const dataUrl = toUrl;
    const blob = base64ToBlob(dataUrl);
    blob.name = getFilename(dataUrl);
    return blob;
};
